import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import DashboardMockup from './DashboardMockup';
import { CodeShowcaseSection, CodeShowcaseContent, CodeShowcaseText } from './styles';

const CodeShowcase: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <CodeShowcaseSection ref={ref} $isVisible={isVisible} id="code-showcase">
      <CodeShowcaseContent>
        <CodeShowcaseText>
          <h2>{t('dashboardDemo.title')}</h2>
          <p>
            {t('dashboardDemo.description')}
          </p>
          <p>
            {t('dashboardDemo.designNote')}
          </p>
        </CodeShowcaseText>

        <DashboardMockup />
      </CodeShowcaseContent>
    </CodeShowcaseSection>
  );
};

export default CodeShowcase;
